import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function NumberInput(props: Props) {
  const ref = React.useRef<HTMLInputElement | null>(null);
  const isAboveMin = () =>
    typeof props.min === "number" ? props.value >= props.min : true;
  const isBelowMax = () =>
    typeof props.max === "number" ? props.value <= props.max : true;
  const isNumber = () => typeof props.value === "number" && !isNaN(props.value);
  const isValid = () => isNumber() && isAboveMin() && isBelowMax();

  React.useEffect(() => {
    if (ref.current && !isNaN(props.value)) {
      ref.current.value = `${props.value}`;
    }
  }, [props.value, ref.current]);

  return (
    <input
      ref={ref}
      type="number"
      placeholder={props.placeholder}
      max={props.max}
      min={props.min}
      step={props.step}
      className={classNames(styles.numberInput, {
        [`${props.className}`]: !!props.className,
      })}
      onChange={({ target }) =>
        props.input(
          parseFloat(
            parseFloat(target.value)
              .toFixed(2)
              .replace(/0+$/, "")
              .replace(/\.$/, ""),
          ),
          isValid(),
        )
      }
      onBlur={props.blur}
      onFocus={props.focus}
      autoFocus={props.autoFocus}
      disabled={props.isDisabled}
    />
  );
}

export { NumberInput };
